import req from './http.js'
import { api, apiAuth } from './fetch'

// 取得Admin相關Api列表
export const apiGetApiList = () => req('get', '/admin/auth/getApiList')

// 賦予權限給使用者
export const apiAssignAuthToUser = (org_id) => req('put', '/admin/auth/assignAuthToUser?org=', org_id)

export const apiGetReadmeInfo = async () => {
  const res = await api('GET', '/view/readme/map?lang=zh-TW')
  if (res.status === 200) {
    return res.data.data
  }
  throw new Error('取得資料失敗')
}

//取得 readme列表
export const apiGetReadmeMap = async (params) => {
  const res = await apiAuth('GET', `/admin/readmeMap`, params)
  if (res.status === 200) {
    return res.data.data
  }
  throw new Error('取得資料失敗')
}

//建立 readme
export const apiCreateReadmeMap = (params) =>
  req('post', `/admin/readmeMap`, params)
    .then(function (resp) {
      return resp.data.data
    })
    .catch(function (error) {
      throw error
    })
// 更新readme
export const apiUpdateReadmeMap = (params) =>
  req('patch', '/admin/readmeMap', params)
    .then(function (resp) {
      return resp.data.data
    })
    .catch(function (error) {
      throw error
    })
